import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT, LIST, ADD } from "const"
import { mtGroupsRoute } from "client/parts/routes"
import { MtGroup } from "server/models"
import { StateType, deepCopy, hasAccess } from "client/utils"
import {
    PRM_GROUP,
    StoreType,
    GroupList,
    GroupFilters,

    LoadAccountGroups,
    SortGroups,
    DeleteGroup,

    setGroupList,
    setGroupIds,
    setGroupSort,
    setGroupFilters,
    addModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
    Button,
    Table,
    TableSearchWrapper,
    SortRows,
    DeleteRow,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import GroupSearch from "client/pages/search/groupSearch"
import Columns from "./columns"

const List = () => {
    const groupList = useSelector((state: StoreType) => state.group.groupList)
    const groupIds = useSelector((state: StoreType) => state.group.groupIds)
    const sortColumn = useSelector((state: StoreType) => state.group.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.group.sortOrder)
    const filters = useSelector((state: StoreType) => state.group.filters)
    const reloadList = useSelector((state: StoreType) => state.group.reloadList)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        LoadAccountGroups(userData.accountId).then((res) => {
            dispatch(setGroupList(res))
            setLoadState(IDLE)
        })
    }, [reloadList])

    useEffect(() => {
        const sortedIds = SortGroups(Object.values(groupList), sortColumn, sortOrder, filters)
        dispatch(setGroupIds(sortedIds))
    }, [groupList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MtGroup, order) => {
        dispatch(setGroupSort(column, order))
    }

    const onFilter = (newFilters: GroupFilters) => {
        dispatch(setGroupFilters(newFilters))
    }

    const onDelete: DeleteRow = (group: MtGroup, callback) => {
        DeleteGroup(group.id, userData.accountId).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const groupListCopy: GroupList = groupList ? deepCopy(groupList) : {}
                delete groupListCopy[group.id]
                dispatch(setGroupList(groupListCopy))
                dispatch(setGroupIds(groupIds.filter((id) => id !== group.id)))
            })
        })
    }

    const columns = Columns()

    const listAccess = hasAccess(PRM_GROUP, LIST)
    const addAccess = hasAccess(PRM_GROUP, ADD)

    if (!listAccess) return <AccessDenied />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.groups}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <TableSearchWrapper>
                    <GroupSearch
                        id="groupList"
                        rightOffset={addAccess}
                        filters={filters}
                        onFilter={onFilter}
                    />
                    {
                        addAccess && (
                            <Button
                                variant="success"
                                onClick={() => dispatch(addModal({ url: `${mtGroupsRoute}/${EDIT}/0` }))}
                            >
                                {lang.add}
                            </Button>
                        )
                    }
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={groupList}
                    dataIds={groupIds}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="sm"
                    showPagination
                    onSort={onSort}
                    onDelete={onDelete}
                />
            </PageContent>
        </Container>
    )
}
export default List
